import calculateFreeShipment from '../general/calculate-free-shipment';

export default function smallCartRefresh({ force = false } = {}) {
    const target = document.querySelector('[data-role="cart-refresh"]');
    if (!target) return;
    if (!force && target.dataset.cartCount === '0') return;

    return fetch('/smallcart', { credentials: 'same-origin', cache: 'no-store' })
        .then(response => {
            if (!response.ok) throw new Error(`smallcart ${response.status}`);
            return response.text();
        })
        .then(html => {
            target.innerHTML = html;
            calculateFreeShipment();
        })
        .catch(err => console.error(err));
}
